var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiggyBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "piggy-bank",
    d: "M9,4H7a4,4,0,0,1,8,0H13A2,2,0,0,0,9,4Zm8,7a1,1,0,1,0,1,1A1,1,0,0,0,17,11Zm7,0v6H22.413A8.026,8.026,0,0,1,19,20.908V24H13V22H11v2H5V20.92A8.041,8.041,0,0,1,1,14a7.957,7.957,0,0,1,.709-3.292A3,3,0,0,1,3,5V7a1,1,0,0,0-.22,1.975A7.987,7.987,0,0,1,9,6h6c.112,0,.224,0,.336.007C16.449,3.006,20,3,20,3V7.773A8.014,8.014,0,0,1,22.414,11Zm-2,2H20.96l-.213-.715A6.035,6.035,0,0,0,15,8H9a6,6,0,0,0-2.57,11.414l.57.271V22H9V20h6v2h2V19.674l.569-.271a6.01,6.01,0,0,0,3.179-3.688L20.96,15H22V13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyBank);
export default __webpack_public_path__ + "static/media/piggy-bank.45fbf58a418a85718c9cd9c6043ca6f2.svg";
export { ForwardRef as ReactComponent };